<template>
  <Dialog :title="$t('Pasarela de pago')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <v-row>
        <v-col cols="6">
          <v-card elevation="2">
            <v-card-title class="titulo_card">{{ $t('Stripe') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="container_info_azul mt-0 mb-0">
                    <p>
                      {{ $t('Añade tu propia pasarela de pago de Stripe para recibir los pagos de tus reservas online.') }}
                      {{ $t('Tan solo tienes que rellenar los campos solicitados.') }}
                      {{ $t('En el siguiente tutorial se detalla como crear una cuenta y donde se encuentra la información solicitada en tu cuenta de Stripe.') }}
                    </p>

                    <ul>
                      <li><a href="https://stripe.com/global" target="_blank">{{ $t('Consultar diponibilidad por paises') }}</a></li>
                      <li><a :href="url_tutorial_stripe" target="_blank">{{ $t('Descargar tutorial') }}</a></li>
                    </ul>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-text-field
                          hide-details
                          v-model="configuracion_marketing.stripe_public_key"
                          :label="$t('Public key Stripe')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                          hide-details
                          v-model="configuracion_marketing.stripe_private_key"
                          :label="$t('Private key Stripe')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card elevation="2">
            <v-card-title class="titulo_card">{{ $t('Paypal') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="container_info_azul mt-0 mb-0">
                    <p>
                      {{ $t('Añade tu propia pasarela de pago de PayPal para recibir los pagos de tus reservas online. Tan solo tienes que rellenar el campo Client ID PayPal. En el siguiente tutorial se detalla como crear una cuenta y donde se encuentra la información solicitada en tu cuenta de PayPal.') }}
                    </p>

                    <ul>
                      <li><a :href="url_tutorial_paypal" target="_blank">{{ $t('Descargar tutorial') }}</a></li>
                    </ul>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-text-field
                          hide-details
                          v-model="configuracion_marketing.paypal_public_key"
                          :label="$t('Client ID Paypal')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <!-- Botón de guardar -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>

  </Dialog>
</template>

<script>

export default {
  name: "FormPasarelasPago",

  props: ['value'],

  data: () => ({
    aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
    configuracion_marketing: {
      stripe_private_key: null,
      stripe_public_key: null,
      paypal_public_key: null
    }
  }),

  methods: {
    /**
     * Recupera la configuración de la api
     * @returns {Promise<void>}
     */
    async get_configuracion(){
      try{
        this.configuracion_marketing = await this.$store.dispatch('configuraciones/get', 'marketing')
        delete this.configuracion_marketing.nombre_app
      }catch (err){}
    },

    /**
     * Guarda la configuración mailchimp
     * @returns {Promise<void>}
     */
    async save(){
      try {
        let configuracion = {...this.configuracion_marketing }
        if(!configuracion['stripe_private_key']){
          delete configuracion['stripe_private_key']
        }

        configuracion = await this.$store.dispatch('configuraciones/save', {
          tipo: 'marketing',
          configuracion: configuracion,
          partial: true
        })

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )

        this.$emit('on_save', this.configuracion_marketing)
        this.$emit('input', false)
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    url_tutorial_stripe() {
      switch (this.$store.getters['locale/get_locale']) {
          case 'es':
              return `${this.aws_s3_bucket_url}tutorial/stripe.pdf`
          case 'it':
              return `${this.aws_s3_bucket_url}tutorial/stripe_it.pdf`
          case 'en':
              return `${this.aws_s3_bucket_url}tutorial/stripe_en.pdf`
      }
    },
    url_tutorial_paypal(){
      switch (this.$store.getters['locale/get_locale']) {
          case 'es':
              return `${this.aws_s3_bucket_url}tutorial/paypal.pdf`
          case 'it':
              return `${this.aws_s3_bucket_url}tutorial/paypal_it.pdf`
          case 'en':
              return `${this.aws_s3_bucket_url}tutorial/paypal_en.pdf`
      }
    }
  },

  mounted() {
    this.get_configuracion()
  }
}
</script>
